// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"466":"ddfe7231","485":"c9de71b2","859":"a3631a60"}[chunkId] + ".chunk.css";
};